import { gql } from "@apollo/client";

export const DELETE_MINUTA = gql`
mutation DeleteMinuta (
  $minutaInput: DeleteMinutaInput!
){
    deleteMinuta (
        minutaInput: $minutaInput
    ) {
      success,
      valorEsperado,
      error
    }
}
`;